import React from 'react'
import { Form, Input } from 'antd'
import Access from '../../../../../../components/access/Access'
import { AssignmentPermissions } from '../../../../../../../../constants/assignment-permissions'
import Text from 'antd/es/typography/Text'

const TestFunctionName = ({ initialValue }) => {
    return (
        <Form.Item
            label='Function name'
            name='functionName'
            rules={[{ required: true, message: 'Please, enter function name' }]}
        >
            <Access
                permissions={[AssignmentPermissions.CAN_EDIT]}
                fallback={<Text>{initialValue}</Text>}
            >
                <Input />
            </Access>
        </Form.Item>
    )
}

export default TestFunctionName
